import React from 'react';
import { Redirect } from "react-router-dom";
import { Route } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { SET_NAVIBAR_SHOW } from 'constants/actionTypes';

import { isUserAuthenticated, removeAll, isAccessToken } from './helpers/authUtils';
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
import { alertMessage, errorMessage } from './constants/commonFunc';

//로그인 관련 컴포넌트
const Landing = React.lazy(() => import('./pages/landing'));
const SignIn = React.lazy(() => import('./pages/auth/SignIn'));
const FindPassword = React.lazy(() => import('./pages/auth/FindPassword'));
const FindPasswordSucceed = React.lazy(() => import('./pages/auth/FindPasswordSucceed'));
const ChangePassword = React.lazy(() => import('./pages/auth/ChangePassword'));
const SignUp = React.lazy(() => import('./pages/auth/SignUp'));
const SignUpInvite = React.lazy(() => import('./pages/auth/SignUpInvite'));
const FindId = React.lazy(() => import('./pages/auth/FindId'));
const Authing = React.lazy(() => import('./components/AuthenticatingLayout'));
const SsoLanding = React.lazy(() => import('./components/SsoLanding'));
const WorkGroup = React.lazy(() => import('./pages/auth/WorkGroup'));
const InVite = React.lazy(() => import('./pages/auth/InVite'));
const CongratuLation = React.lazy(() => import('./pages/auth/CongratuLation'));

//메인 화면 관련 컴포넌트
const Home = React.lazy(() => import('./pages/main/home'));
const Manage = React.lazy(() => import('./pages/manage'));
const SalesLog = React.lazy(() => import('./pages/manage/saleslog'));
const NeedsEdit = React.lazy(() => import('./pages/manage/saleslog/needsedit'));
const NeedsList = React.lazy(() => import('./pages/manage/saleslog/needsedit/needslist'));


const Upload = React.lazy(() => import('./pages/manage/upload'));
const Temporary = React.lazy(() => import('./pages/manage/upload/temporary'));

//고객, 고객담당자 관련 route 
const Customer = React.lazy(() => import('./pages/customer'))
const CustomerAdd = React.lazy(() => import('./pages/customer/register'))
const CustomerManagerRegister = React.lazy(() => import('./pages/customer/registerManager'))
const CustomerDetails = React.lazy(() => import('./pages/customer/profile'))
const CustomerEdit = React.lazy(() => import('./pages/customer/edit'))
const ManagerProfile = React.lazy(() => import('./pages/customer/profile/manager'))
const ManagerEdit = React.lazy(() => import('./pages/customer/edit/manager'))
const CustomerAddExcel = React.lazy(() => import('./pages/customer/registerExcel'))

//일정
const Calendar = React.lazy(() => import('./pages/calendar'))
const CalendarRegister = React.lazy(() => import('./pages/calendar/registerCalendar'))


//워크그룹, 그룹 수정 , 그룹 나가기, 일지 키워드 알림 설정
const Workgroup = React.lazy(() => import('./pages/workgroup'))
const WorkgroupReg = React.lazy(() => import('./pages/workgroup/register'))
const WorkgroupUpd = React.lazy(() => import('./pages/workgroup/update'))
const WorkgroupDeptReg = React.lazy(() => import('./pages/workgroup/dept'))
const WorkgroupMember = React.lazy(() => import('./pages/workgroup/member'))
const WorkgroupMemberInvite = React.lazy(() => import('./pages/workgroup/member/invite'))
const WorkgroupMemberProfile = React.lazy(() => import('./pages/workgroup/member/profile'))
const WorkgroupOut = React.lazy(() => import('./pages/workgroup/outwgroup'))
const WorkgroupDel = React.lazy(() => import('./pages/workgroup/delwgroup'))
const WorkgroupChg = React.lazy(() => import('./pages/workgroup/chgwgroup'))
const WorkgroupLogKword = React.lazy(() => import('./pages/workgroup/logkword'))

//프로필 , 공지사항, 기념일, 알림
const myProfile = React.lazy(() => import('./pages/etc/profile'))
const wgroupNotice = React.lazy(() => import('./pages/etc/notice/group'))
const wgroupNoticeRegi = React.lazy(() => import('./pages/etc/notice/group/register'))
const wgroupNoticeDetail = React.lazy(() => import('./pages/etc/notice/group/detail'))
const wgroupNoticeUpd = React.lazy(() => import('./pages/etc/notice/group/update'))
const systemNotice = React.lazy(() => import('./pages/etc/notice/system'))
const systemNoticeRegi = React.lazy(() => import('./pages/etc/notice/system/register'))
const systemNoticeDetail = React.lazy(() => import('./pages/etc/notice/system/detail'))
const systemNoticeUpd = React.lazy(() => import('./pages/etc/notice/system/update'))
const anniversary = React.lazy(() => import('./pages/etc/notice/anniversary'))
const Phistory = React.lazy(() => import('./pages/membership/phistory'))


// 설정 등
const AppInfo = React.lazy(() => import('./pages/appInfo'))
const NotificationSetting = React.lazy(() => import('./pages/settings/notification'))
const NotificationList = React.lazy(() => import('./pages/notification'))

// device token
const SaveDevice = React.lazy(() => import('./pages/etc/devicetoken'))

//지원센터 
const SupportPage = React.lazy(() => import('./pages/support'))
const MyInquiryDetails = React.lazy(() => import('./pages/support/detail'))

//멤버십
const MembershipPage = React.lazy(() => import('./pages/membership'))
const PaymentPage = React.lazy(() => import('./pages/membership/payment'))
const GpaymentPage = React.lazy(() => import('./pages/membership/gpayment'))



const LandingRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => {
    const isTokenValid = isUserAuthenticated();

    if (props.match.path === '/' && isTokenValid) {
      console.log('redirect!!!!!!!')
      return <Redirect push to={{ pathname: '/main/manage', state: { from: props.location } }} />
    }
    console.log('Component props')
    return <Component {...props} />
  }} />
);

const MainRoute = ({ component: Component, roles, ...rest }) => (
  (rest.path == '/main/manage' || rest.path == '/main/customer') ?
    <CacheRoute
      {...rest} render={props => {
        // console.log('cashRoute', { ...rest })

        if (props.history.location.state === 'needReload') {
          window.location.reload();
        }

        let isTokenOK = isAccessToken().then((res) => {
          if (res == 'NoToken') {
            //errorMessage('로그인정보가 없습니다. 다시 시도하세요.')
            console.log('LOGIN PUSH :: MainRoute NoToken res :: ', res)
            removeAll();
            props.history.push('/signin')

          } else if (res == 'ReToken') {
            console.log('LOGIN PUSH :: MainRoute ReToken res :: ', res)
            window.location.reload();

          } else if (res == 'NoWorkgroup') {
            if (props.history.location.pathname != '/main/workgroup/chgwgroup' &&
              props.history.location.pathname != '/main/workgroup/register') {

              props.history.push('/main/workgroup/chgwgroup')
            }
          }
        })
        return <Component {...props} />
      }} />
    :
    <Route
      {...rest} render={props => {

        let isTokenOK = isAccessToken().then((res) => {
          if (res == 'NoToken') {

            console.log('LOGIN PUSH :: MainRoute NoToken res :: ', res)
            removeAll();
            props.history.push('/signin')

          } else if (res == 'ReToken') {
            console.log('LOGIN PUSH :: MainRoute ReToken res :: ', res)
            window.location.reload();

          } else if (res == 'NoWorkgroup') {
            if (props.history.location.pathname != '/main/workgroup/chgwgroup' &&
              props.history.location.pathname != '/main/workgroup/register') {

              props.history.push('/main/workgroup/chgwgroup')
            }
          }
        })
        return <Component {...props} />
      }} />

);

const routes = [
  //Main Route
  { path: '/main', name: 'Home', component: Home, route: MainRoute, exact: true },
  //일지
  { path: '/main/manage/saleslog/:id', name: 'SalesLog', component: SalesLog, route: MainRoute, exact: true },
  { path: '/main/manage/saleslog/needsedit/:id', name: 'NeedsEdit', component: NeedsEdit, route: MainRoute, exact: true },
  { path: '/main/manage/saleslog/needsedit/needslist/:id', name: 'NeedsList', component: NeedsList, route: MainRoute, exact: true },


  { path: '/main/manage', name: 'Manage', component: Manage, route: MainRoute, exact: true },
  { path: '/main/upload', name: 'Upload', component: Upload, route: MainRoute, exact: true },
  { path: '/main/upload/:id', name: 'Upload', component: Upload, route: MainRoute, exact: true },
  // { path: '/main/upload/temporary/:id', name: 'Temporary', component: Temporary, route: MainRoute, exact: true },
  //고객사 
  { path: '/main/customer', name: 'Customer', component: Customer, route: MainRoute, exact: true },
  { path: '/main/customer/register', name: 'CustomerAdd', component: CustomerAdd, route: MainRoute, exact: true },
  { path: '/main/customer/register_manager/:accId/:managerId', name: 'ManagerRegister', component: CustomerManagerRegister, route: MainRoute, exact: true },
  { path: '/main/customer/details/:accId/:managerId', name: 'CustomerDetails', component: CustomerDetails, route: MainRoute, exact: true },
  { path: '/main/customer/details/:accId', name: 'CustomerDetails', component: CustomerDetails, route: MainRoute, exact: true },
  { path: '/main/customer/edit/:accId/:managerId', name: 'CustomerEdit', component: CustomerEdit, route: MainRoute, exact: true },
  { path: '/main/manager/profile/:accId/:singleId', name: 'ManagerProfile', component: ManagerProfile, route: MainRoute, exact: true },
  { path: '/main/manager/editManager/:singleId/:accId', name: 'ManagerEdit', component: ManagerEdit, route: MainRoute, exact: true },
  { path: '/main/customer/registerexcel', name: 'CustomerAddExcel', component: CustomerAddExcel, route: MainRoute, exact: true },

  //일정
  { path: '/main/calendar', name: 'Calendar', component: Calendar, route: MainRoute, exact: true },
  { path: '/main/calendar/register', name: 'CalendarRegister', component: CalendarRegister, route: MainRoute, exact: true },

  //워크그룹 
  { path: '/main/workgroup', name: 'Workgroup', component: Workgroup, route: MainRoute, exact: true },
  { path: '/main/workgroup/register', name: 'WorkgroupReg', component: WorkgroupReg, route: MainRoute, exact: true },
  { path: '/main/workgroup/update', name: 'WorkgroupUpd', component: WorkgroupUpd, route: MainRoute, exact: true },
  { path: '/main/workgroup/dept', name: 'WorkgroupDeptReg', component: WorkgroupDeptReg, route: MainRoute, exact: true },
  { path: '/main/workgroup/member', name: 'WorkgroupMember', component: WorkgroupMember, route: MainRoute, exact: true },
  { path: '/main/workgroup/member/invite', name: 'WorkgroupMemberInvite', component: WorkgroupMemberInvite, route: MainRoute, exact: true },
  { path: '/main/workgroup/member/profile/:memberId', name: 'WorkgroupMemberProfile', component: WorkgroupMemberProfile, route: MainRoute, exact: true },
  { path: '/main/workgroup/outwgroup', name: 'WorkgroupOut', component: WorkgroupOut, route: MainRoute, exact: true },
  { path: '/main/workgroup/delwgroup', name: 'WorkgroupDel', component: WorkgroupDel, route: MainRoute, exact: true },
  { path: '/main/workgroup/chgwgroup', name: 'WorkgroupChg', component: WorkgroupChg, route: MainRoute, exact: true },
  { path: '/main/workgroup/logkword', name: 'WorkgroupLogKword', component: WorkgroupLogKword, route: MainRoute, exact: true },

  //기타 (프로필 수정 및 공지사항)
  { path: '/main/etc/profile', name: 'myProfile', component: myProfile, route: MainRoute, exact: true },
  { path: '/main/etc/notice/group', name: 'wgroupNotice', component: wgroupNotice, route: MainRoute, exact: true },
  { path: '/main/etc/notice/group/register', name: 'wgroupNoticeRegi', component: wgroupNoticeRegi, route: MainRoute, exact: true },
  { path: '/main/etc/notice/group/detail/:noticeId', name: 'wgroupNoticeDetail', component: wgroupNoticeDetail, route: MainRoute, exact: true },
  { path: '/main/etc/notice/group/update/:noticeId', name: 'wgroupNoticeUpd', component: wgroupNoticeUpd, route: MainRoute, exact: true },
  { path: '/main/etc/notice/system', name: 'systemNotice', component: systemNotice, route: MainRoute, exact: true },
  { path: '/main/etc/notice/system/register', name: 'systemNoticeRegi', component: systemNoticeRegi, route: MainRoute, exact: true },
  { path: '/main/etc/notice/system/detail/:noticeId', name: 'systemNoticeDetail', component: systemNoticeDetail, route: MainRoute, exact: true },
  { path: '/main/etc/notice/system/update/:noticeId', name: 'systemNoticeUpd', component: systemNoticeUpd, route: MainRoute, exact: true },
  { path: '/main/etc/notice/anniversary', name: 'anniversary', component: anniversary, route: MainRoute, exact: true },

  //프로필 및 설정 등
  { path: '/main/information', name: 'AppInfo', component: AppInfo, route: MainRoute, exact: true },
  { path: '/main/notification/setting', name: 'NotificationSetting', component: NotificationSetting, route: MainRoute, exact: true },
  { path: '/main/notification/lists', name: 'NotificationList', component: NotificationList, route: MainRoute, exact: true },
  { path: '/main/membership/phistory', name: 'Phistory', component: Phistory, route: MainRoute, exact: true },

  //멤버십
  { path: '/main/membership', name: 'MembershipPage', component: MembershipPage, route: MainRoute, exact: true },
  { path: '/main/membership/payment', name: 'PaymentPage', component: PaymentPage, route: MainRoute, exact: true },
  { path: '/main/membership/gpayment/:id', name: 'GpaymentPage', component: GpaymentPage, route: MainRoute, exact: true },



  //지원
  { path: '/main/support', name: 'SupportPage', component: SupportPage, route: MainRoute, exact: true },
  { path: '/main/support/details/:id', name: 'MyInquiryDetails', component: MyInquiryDetails, route: MainRoute, exact: true },

  //devict token
  { path: "/main/etc/savedevice/:device", name: 'SaveDevice', component: SaveDevice, route: MainRoute, exact: true },

  //landing Route
  { path: "/", name: 'Landing', component: Landing, route: LandingRoute, exact: true },
  { path: '/signin', name: 'SignIn', component: SignIn, route: LandingRoute, exact: true },
  { path: '/findpw', name: 'FindPassword', component: FindPassword, route: LandingRoute, exact: true },
  { path: '/findpwsucceed', name: 'FindPasswordSucceed', component: FindPasswordSucceed, route: LandingRoute, exact: true },
  { path: '/change_pw/:email/:code', name: 'ChangePassword', component: ChangePassword, route: LandingRoute, exact: true },
  { path: '/signup', name: 'SignUp', component: SignUp, route: LandingRoute, exact: true },
  { path: '/signup/invite/:inviteCode/:inviteEmail/:useName', name: 'SignUpInvite', component: SignUpInvite, route: LandingRoute, exact: true },
  { path: '/findid', name: 'FindId', component: FindId, route: LandingRoute, exact: true },
  { path: '/authing', name: 'Authing', component: Authing, route: LandingRoute, exact: true },
  { path: '/sso', name: 'Sso', component: SsoLanding, route: LandingRoute, exact: true },
  { path: '/workgroup', name: 'WorkGroup', component: WorkGroup, route: LandingRoute, exact: true },
  { path: '/invite', name: 'InVite', component: InVite, route: LandingRoute, exact: true },
  { path: '/congratulation', name: 'CongratuLation', component: CongratuLation, route: LandingRoute, exact: true },
];

export { routes };